/**
 * The projects AIOE is built on that a package list cannot show: code ported from elsewhere, a
 * design followed, a runtime it ships on. The Attributions tab in Settings shows them above the
 * packages. Ported code also keeps its notice in THIRD-PARTY-NOTICES.md; the research behind the
 * borrowed designs is in docs/research/2026-10-external-projects-audit.md.
 *
 * Names are used factually, to say where an idea or a piece of code came from. None of these
 * projects endorses AIOE.
 */

export interface Credit {
  name: string;
  url: string;
  /** Who made it, and what it gave AIOE. */
  description: string;
  /** The terms, where they apply. */
  license?: string;
}

export const CREDITS: readonly Credit[] = [
  {
    name: 'WireGuard',
    url: 'https://www.wireguard.com',
    description:
      'Jason A. Donenfeld / WireGuard LLC. The wireguard-go implementation (golang.zx2c4.com/wireguard) the aioe-mesh agent builds the organisation’s private network on. “WireGuard” is a registered trademark of Jason A. Donenfeld.',
    license: 'MIT',
  },
  {
    name: 'IP Geolocation by DB-IP',
    url: 'https://db-ip.com',
    description:
      'DB-IP.com. The IP to City Lite database the audit trail names approximate places from (country, region and city), read on the server itself so no address is sent anywhere. Fetched each month when the platform’s image is built.',
    license: 'CC BY 4.0',
  },
  {
    name: 'OpenClaw Enterprise',
    url: 'https://github.com/openclaw/openclaw-enterprise',
    description:
      'OpenAI. The redactor that masks credentials in what machines report is ported from it, and the append-only audit trail follows its design.',
    license: 'MIT (Copyright © 2026 OpenAI)',
  },
  {
    name: 'OpenShell',
    url: 'https://github.com/NVIDIA/openshell',
    description:
      'NVIDIA. The vocabulary of the policy’s network clause: which programs may reach which endpoints, and which requests or tools there. Design only; no code is used.',
    license: 'Apache-2.0',
  },
  {
    name: 'RUBRIC Agentic OS v2',
    url: 'https://robonuggets.substack.com',
    description:
      'Jay E at RoboNuggets. The memory explorer’s Universe, Map and Timeline come from AI Workbench’s Memory control, which adapts the Second Brain of RUBRIC Agentic OS v2: one picture of every item seen three ways, gliding between them.',
    license: 'MIT (Copyright © Jay E | RoboNuggets)',
  },
  {
    name: 'pixel-agents',
    url: 'https://github.com/pixel-agents-hq/pixel-agents',
    description:
      'The pixel characters team members are drawn with come from AI Workbench’s pixel office, which grew from this project. Thanks to @pablodelucca.',
    license: 'MIT (Copyright © 2026 Pablo De Lucca)',
  },
  {
    name: 'Node.js',
    url: 'https://nodejs.org',
    description: 'OpenJS Foundation and contributors. The runtime the platform API runs on, inside its container image.',
    license: 'MIT',
  },
  {
    name: 'Go',
    url: 'https://go.dev',
    description: 'The Go Authors. The language and standard library the aioe-mesh agent is built with; the standard library ships inside each agent binary.',
    license: 'BSD-3-Clause',
  },
];
